import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Grid,
  Typography,
  Link,
  Divider,
} from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
// import our utility functions for working with filters and languages
import { i18n } from "../util/i18n";

import ResetFiltersButton from "./ResetFiltersButton";
import TextSearchFilterInput from "./TextSearchFilterInput";
import WorkloadFilterSlider from "./WorkloadFilterSlider";
import AttributeFilterAutocomplete from "./AttributeFilterAutocomplete";
import JobAboSubscriptionModal from "./JobAboSubscriptionModal";

import settings from "../settings";

/**
 * A React component holding a set of filters. Reasonable default implementation.
 * It needs the filterParams state (and setter), and passes it to the child filter components.
 *
 * It supports multiple modes:
 * - disbaleHeader=true: Don't show the header with the search field
 * - disableButtons=true: Don't show the buttons to reset the filters or to subscribe to a job Abo
 * - DefaultExpanded=false: Don't show the Accordion expanded by default
 */

const FilterSection = ({
  filterParams,
  setFilterParams,
  showSubmitButton,
  disableHeader = false,
  disableButtons = false,
  disableWorkload = false,
  attributes = null,
  defaultExpanded = true,
  totalJobs,
  ...props
}) => {
  const [expanded, setExpanded] = React.useState(defaultExpanded);

  const handleAccordionButton = () => {
    setExpanded((prev) => !prev);
  };

  return (
    <>
      {!disableHeader && (
          <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="flex-end"
              spacing={4}
              rowSpacing={4}
          >
            <Grid item xs={12}>
              <TextSearchFilterInput
                  filterParams={filterParams}
                  setFilterParams={setFilterParams}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <AttributeFilterAutocomplete
                  filterParams={filterParams}
                  setFilterParams={setFilterParams}
                  attributes={attributes}
                  filterAttributeId={10}
                  label={i18n.translations.filterBerufsgruppeLabel}
              />
            </Grid>
            <Grid item xs={12} md={6} >
              <AttributeFilterAutocomplete
                  filterParams={filterParams}
                  setFilterParams={setFilterParams}
                  attributes={attributes}
                  filterAttributeId={20}
                  label={i18n.translations.filterKlinikBereichLabel}
              />
            </Grid>
            <Grid item xs={12} md={6} >
              <AttributeFilterAutocomplete
                  filterParams={filterParams}
                  setFilterParams={setFilterParams}
                  attributes={attributes}
                  filterAttributeId={30}
                  label={i18n.translations.filterArbeitsortLabel}
              />
            </Grid>
            {!disableWorkload && (
                <Grid item xs={12} md={6}>
                  <WorkloadFilterSlider
                      filterParams={filterParams}
                      setFilterParams={setFilterParams}
                  />
                </Grid>
            )}
            {!disableButtons && (
                <Grid item md={12} sx={{textAlign:'right'}}>
                  <ResetFiltersButton
                      filterParams={filterParams}
                      setFilterParams={setFilterParams}
                  />
                </Grid>
            )}
          </Grid>
      )}


      {!settings.autoSubmit && (
          <div
              className="buttons"
          >
            <ResetFiltersButton
                filterParams={filterParams}
                setFilterParams={setFilterParams}
            />
          </div>
      )}
    </>
  );
};

export default FilterSection;
